import React from 'react';
import { SearchResultItem } from './types';
import { AppIcon, TypeIcon } from './icons';
import { formatDate, highlight } from './utils/helpers';
import './GlobalSearch.css';

interface ResultCardProps {
  item: SearchResultItem;
  onOpen: (item: SearchResultItem) => void;
}

export const ResultCard: React.FC<ResultCardProps> = ({ item, onOpen }) => {
  return (
    <div
      className="kxd-result-card"
      onClick={() => onOpen(item)}
    >
      <div className="kxd-card-meta">
        <span className="kxd-card-type-badge">
          <span className="kxd-suggestion-icon">{TypeIcon[item.type] || null}</span>
          <span>{item.type}</span>
        </span>
        <span className="kxd-suggestion-breadcrumb">{item.breadcrumb}</span>
        <span style={{ whiteSpace: 'nowrap' }}>• Updated {formatDate(item.updatedAt)}</span>
      </div>
      <div className="kxd-card-title">{item._q ? highlight(item.title, item._q) : item.title}</div>
      <div className="kxd-card-snippet">{item._q ? highlight(item.snippet, item._q) : item.snippet}</div>
      <div className="kxd-card-tags">
        <span className="kxd-tag kxd-tag-indigo">
          {AppIcon[item.app]}
          <span>{item.app}</span>
        </span>
        {item.project && (
          <span className="kxd-tag kxd-tag-blue">{item.project}</span>
        )}
        {item.discipline && (
          <span className="kxd-tag kxd-tag-amber">{item.discipline}</span>
        )}
        {item.status && (
          <span className="kxd-tag kxd-tag-emerald">{item.status}</span>
        )}
      </div>
      <div className="kxd-card-actions">
        <button
          className="kxd-action-btn kxd-btn-gray"
          onClick={(e) => {
            e.stopPropagation();
            onOpen(item);
          }}
        >
          Open
        </button>
        {item.app === "3D Visualization" && (item.type === "Model" || item.type === "Tag") && (
          <button
            className="kxd-action-btn kxd-btn-blue"
            onClick={(e) => {
              e.stopPropagation();
              alert("Open in 3D Viewer → " + item.url);
            }}
          >
            Open in 3D
          </button>
        )}
        {item.type === "Document" && (
          <button
            className="kxd-action-btn kxd-btn-green"
            onClick={(e) => {
              e.stopPropagation();
              alert("Preview Document → " + item.url);
            }}
          >
            Preview
          </button>
        )}
      </div>
    </div>
  );
};
